// x-publication-tabs.js

/*
This script handles display of publications lists based on their tab-selectors.
It also handles click on summary links (that open summaries inside each publication).
*/

export default function xPublicationTabs() {

  const publicationTabs = document.getElementById("vrtx-publication-tabs");

  if (publicationTabs) {
    const tabLinkList = publicationTabs.querySelector("ul:first-child");
    const tabLinks = tabLinkList.querySelectorAll("a");
    const containers = publicationTabs.querySelectorAll("[id*='vrtx-publication-tab-']");
    const firstContainer = publicationTabs.querySelector("#vrtx-publication-tab-1");
    const summaryLinks = publicationTabs.querySelectorAll("a.vrtx-publication-summary");

    // Set first container as selected
    firstContainer.classList.add("selected");



    /**************************************
     * Tab selector links
    ***************************************/

    tabLinks.forEach((link, index) => {

      // Setup aria
      link.setAttribute("role", "button");
      if (index === 0) {
        link.setAttribute("aria-expanded", "true");
      } else {
        link.setAttribute("aria-expanded", "false");
      }

      // Connect aria to link target
      const linkReference = link.getAttribute("href").replace("#", "");
      link.setAttribute("aria-controls", linkReference);

      // Click event
      link.addEventListener("click", (e) => {
        e.preventDefault();

        // Update aria
        tabLinks.forEach(link => {
          link.setAttribute("aria-expanded", "false");
        });
        link.setAttribute("aria-expanded", "true");

        // Get link target
        const linkTarget = document.getElementById(linkReference);

        // Clear selected classes
        containers.forEach(container => {
          container.classList.remove("selected");
        });

        // Add selected class to link target
        linkTarget.classList.add("selected");
        linkTarget.setAttribute("tabindex", "-1");
        linkTarget.focus();
        linkTarget.scrollIntoView();
      });
    });



    /**************************************************************
     * Summary links (that open summaries inside each publication)
    ***************************************************************/

    summaryLinks.forEach(summaryLink => {

      // Setup aria
      summaryLink.setAttribute("role", "button");

      // Click event
      summaryLink.addEventListener("click", (e) => {
        e.preventDefault();

        // Toggle expanded class and aria state
        const isExpanded = summaryLink.classList.toggle("expanded");
        summaryLink.setAttribute("aria-expanded", isExpanded);

        // Remove style attribute and use toggle open class instead
        const summary = summaryLink.nextElementSibling;
        summary.removeAttribute("style");
        summary.classList.toggle("open");
      });
    });
  }
}